import React, { useState } from 'react';
import {
  formatDateAr,
  getVoucherCash,
  getVoucherName,
  getVoucherPoints,
  getVoucherStatus,
  money,
} from '../../utils/loyalty';

const STATUS_CONFIG = {
  ACTIVO:   { label: 'Vigente',  bg: '#dcfce7', color: '#15803d' },
  USADO:    { label: 'Usado',    bg: '#f3f4f6', color: '#6b7280' },
  VENCIDO:  { label: 'Vencido', bg: '#fef2f2', color: '#dc2626' },
};

function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.VENCIDO;
  return (
    <span style={{ background: cfg.bg, color: cfg.color }}
      className="shrink-0 h-5 px-2.5 rounded-full text-[10px] font-black inline-flex items-center uppercase tracking-wide">
      {cfg.label}
    </span>
  );
}

const VoucherCard = ({ voucher }) => {
  const [copied, setCopied] = useState(false);
  const status   = getVoucherStatus(voucher);
  const isActive = status === 'ACTIVO';
  const cash     = getVoucherCash(voucher);
  const points   = getVoucherPoints(voucher);
  const code     = voucher.code || '—';
  const vence    = voucher.fechaVencimiento || voucher.expiracion;

  const copyCode = () => {
    navigator.clipboard?.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <article className={`rounded-2xl overflow-hidden border ${isActive ? 'border-red-100 bg-white shadow-sm' : 'border-gray-100 bg-gray-50'}`}>

      {/* Header */}
      <div className={`px-4 py-2.5 flex items-center justify-between gap-3 ${isActive ? 'bg-maja-red' : 'bg-gray-100'}`}>
        <p className={`font-black text-sm leading-tight truncate ${isActive ? 'text-white' : 'text-gray-500'}`}>
          {getVoucherName(voucher)}
        </p>
        {isActive
          ? <span className="shrink-0 h-5 px-2.5 rounded-full text-[10px] font-black inline-flex items-center bg-white/20 text-white uppercase tracking-wide">Vigente</span>
          : <StatusBadge status={status} />
        }
      </div>

      {/* Código */}
      <div className={`px-4 py-3 flex items-center justify-between gap-3 ${!isActive ? 'opacity-50' : ''}`}>
        <div className="min-w-0">
          {isActive && (
            <p className="text-[9px] font-black uppercase tracking-widest text-gray-400 mb-0.5">
              Mostrá en caja
            </p>
          )}
          <p className={`font-mono font-black tracking-widest select-all ${isActive ? 'text-xl text-gray-900' : 'text-base text-gray-400'}`}>
            {code}
          </p>
        </div>
        <div className="shrink-0 flex flex-col items-end gap-1">
          {isActive && (
            <button onClick={copyCode}
              className="h-7 px-3 rounded-full border border-gray-200 text-xs font-black text-gray-500 hover:border-maja-red hover:text-maja-red transition-colors">
              {copied ? '✓' : 'Copiar'}
            </button>
          )}
          <p className={`text-xs font-extrabold ${isActive ? 'text-maja-red' : 'text-gray-400'}`}>
            {money(points)} pts{cash > 0 ? ` + $${money(cash)}` : ''}
          </p>
        </div>
      </div>

      {/* Vencimiento / fecha uso */}
      {vence && (
        <div className={`border-t px-4 py-1.5 ${isActive ? 'border-dashed border-gray-200 bg-amber-50' : 'border-gray-100'}`}>
          <p className={`text-[10px] font-extrabold uppercase tracking-wide ${isActive ? 'text-amber-600' : 'text-gray-400'}`}>
            {isActive ? `Vence ${formatDateAr(vence)}` : `Venció ${formatDateAr(vence)}`}
          </p>
        </div>
      )}

    </article>
  );
};

export default VoucherCard;
